import {
  VEHICLEFUELSETTING_GET,
  VEHICLEFUELSETTING_POST,
  VEHICLEFUELSETTING_PUT,
  VEHICLEFUELSETTING_LOADING,
  VEHICLEFUELSETTING_ERROR,
  VEHICLEFUELSETTING_RESET,
} from '../types';
import api from '../../../utils/functions/api';

export const vehicleFuelSettingGet = (employeeId) => async (dispatch) => {
  try {
    dispatch({ type: VEHICLEFUELSETTING_LOADING });
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/vehicle-fuel-setting/employee/${employeeId}`,
    );
    if (status === 200) {
      dispatch({ type: VEHICLEFUELSETTING_GET, payload: data });
    } else {
      dispatch({ type: VEHICLEFUELSETTING_RESET });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLEFUELSETTING_RESET });
  }
};

export const vehicleFuelSettingUpsert = (payload) => async (dispatch) => {
  try {
    dispatch({ type: VEHICLEFUELSETTING_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/vehicle-fuel-setting`,
      payload,
    );
    dispatch({ type: VEHICLEFUELSETTING_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLEFUELSETTING_ERROR });
    throw error;
  }
};

export const vehicleFuelSettingPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: VEHICLEFUELSETTING_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/vehicle-fuel-setting/${id}`,
      payload,
    );
    dispatch({ type: VEHICLEFUELSETTING_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: VEHICLEFUELSETTING_ERROR });
    throw error;
  }
};

export const vehicleFuelSettingReset = () => ({ type: VEHICLEFUELSETTING_RESET });
